import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialState = {
    dependentCurveId: null,
    independentCurveId: null,
    structure1: null,
    structure2: null,
    isFwd: false,
    isImm: false,
    meetingDate: '',
    immFwd: null,
    immLabel: null,
    regressStr1: null,
    tenorDateRange: {
        label: '2Y',
        unit: 'Y',
        value: 2
    }
};

let irsContextSlice = (set) => ({
    ...initialState,
    updateContext: (data) => set((state) => ({ ...state, ...data })),
    resetContext: () => set(initialState)
});

irsContextSlice = immer(irsContextSlice);
const useIrsContextStore = create(irsContextSlice);

export default useIrsContextStore;
